
<template>
  <div>
    <v-col
      class="px-0 py-4 py-md-10"
      xs="12"
      offset-xs="0"
      sm="10"
      offset-sm="1"
      md="8"
      offset-md="2"
    >
      <v-combobox
        :menu-props="{ auto: false, maxHeight: 170 }"
        clearable
        hide-details
        outlined
        persistent-hint
        solo
        ref="inputLocalizacion"
        v-model="autocompleteLocationModel"
        :items="locationEntries"
        :search-input.sync="locationSearchText"
        :loading="checkEveryLoading"
        :disabled="checkEveryLoading"
        no-filter
        item-text="value"
        item-value="id"
        hide-no-data
        return-object
        error-messages
        :label="$t('pedido.modo.inputlocalizacion.textField1.label.introduce')"
        append-icon="mdi-magnify"
        @click:append="geocodeAddress($event)"
        @input="geocodeAddress($event)"
        @keyup.enter="keyEnter"
        @focus="inputFocus()"
      >
        <template slot="item" slot-scope="{ item, parent }">
          <v-list-item-content>
            <p>{{item.value}}</p>
          </v-list-item-content>
        </template>
      </v-combobox>
    </v-col>
    <dialogDireccion />
  </div>
</template>

<script>
import { GetSuggestions } from "@/utils/PlaceUtils";
import { mapState, mapActions } from "vuex";
import dialogDireccion from "@/components/Pedidos/pedir_dialogDireccion.vue";

export default {
  name: "input-localizacion",
  props: {
    modo: String
  },
  components: {
    dialogDireccion
  },
  data() {
    return {};
  },
  mounted() {
    this.cargarLogica();
  },
  computed: {
    ...mapState({
      listadoRestaurantes: state => state.pedido.listadoRestaurantes,
      navigatorAddress: state => state.pedido.navigatorAddress,
      addressObject: state => state.pedido.addressObject,
      codigoProvincia: state => state.pedido.addressObject.codigoProvincia,
      isLogged: state => state.auth.isLogged,
      direcciones: state => state.direcciones.direcciones,
      dirPidiendo: state => state.direcciones.dirPidiendo,
      dirInput: state => state.direcciones.direccionInput,
      loadingDialog: state => state.pedido.loadingDialog,
      loadingDireccionNavegador: state =>
        state.direcciones.loadingDireccionNavegador,
      isMobile: state => state.app.isMobile,
      isSafari: state => state.app.isSafari
    }),
    autocompleteLocationModel: {
      get() {
        return this.$store.state.pedido.navigatorAddress;
      },
      set(value) {
        this.$store.commit("pedido/setNavigatorAddress", value);
      }
    },
    locationSearchText: {
      get() {
        return this.$store.state.direcciones.locationSearchText;
      },
      set(v) {
        this.$store.commit("direcciones/setLocationSearchText", v);
      }
    },
    locationEntries: {
      get() {
        return this.$store.state.direcciones.locationEntries;
      },
      set(v) {
        this.$store.commit("direcciones/setLocationEntries", v);
      }
    },
    buscando: {
      get() {
        return this.$store.state.direcciones.buscando;
      },
      set(v) {
        this.$store.commit("direcciones/setBuscando", v);
      }
    },
    dialogDireccion: {
      get() {
        return this.$store.state.pedido.dialogDireccion;
      },
      set(value) {
        this.$store.commit("pedido/setDialogDireccion", value);
      }
    },
    direccionCache: {
      get() {
        return this.$store.state.direcciones.direccionCache;
      },
      set(value) {
        this.$store.commit("direcciones/setDireccionCache", value);
      }
    },
    loadingRest: {
      get() {
        return this.$store.state.restaurante.loadingRest;
      },
      set(value) {
        this.$store.commit("restaurante/setLoadingRest", value);
      }
    },
    checkEveryLoading() {
      let res =
        this.loadingRest ||
        this.loadingDireccionNavegador ||
        this.loadingDialog;

      return res;
    }
  },
  watch: {
    locationSearchText(newVal) {
      var _vue = this;
      // If less than 3 chars typed, do not search
      if (!newVal || newVal.length <= 4) {
        this.locationEntries = [];
        return;
      }

      // Call the method from the previous section here
      GetSuggestions(newVal)
        .then(function(res) {
          console.log(res);
          if (res != "ZERO_RESULTS") {
            _vue.locationEntries = res;
          } else {
            console.log("aqui");
            _vue.modo == "domicilio"
              ? (_vue.locationEntries = [
                  { value: "No se localiza. Escribir a mano." }
                ])
              : null; //Sin alternativa para recoger
          }
        })
        .catch(function(err) {
          // error handling goes here
        })
        .finally(function() {});
    },
    direcciones(newVal, oldVal) {
      if (oldVal.length != newVal.length) {
        //Carga si hay direcciones diferentes
        this.cargarDireccionesUsuario();
      }
    }
  },
  methods: {
    ...mapActions({
      cargarLogicaRecoger: "direcciones/cargarLogicaRecoger",
      cargarLogicaDomicilio: "direcciones/cargarLogicaDomicilio",
      openDialogDireccion: "direcciones/openDialogDireccion",
      loadAndOrderRestaurants: "direcciones/loadAndOrderRestaurants",
      geocodeAddress: "direcciones/geocodeInput",
      getNavigatorLocation: "direcciones/getNavigatorLocation"
    }),
    inputFocus() {
      let _vue = this;
      let duration = _vue.isSafari ? 0 : 500;
      let offset = _vue.isMobile ? 50 : 0;

      this.$vuetify.goTo(this.$refs.inputLocalizacion.$el, {
        duration: duration,
        offset: offset,
        easing: "easeOutQuad"
      });
    },
    // keyPress() {
    //   let inputPosition = this.$refs.inputLocalizacion.$el.clientHeight+this.$refs.inputLocalizacion.$el.offsetTop+78
    //   let contentPosition = document.getElementsByClassName("menuable__content__active")[0].offsetTop
    //   let resta = inputPosition-contentPosition
    //   console.log( inputPosition, contentPosition, resta)

    //   if(resta > 0){
    //     document.getElementsByClassName("menuable__content__active")[0].style.marginTop = resta+"px";
    //   }else{
    //     document.getElementsByClassName("menuable__content__active")[0].style.marginTop = "0px";
    //   }

    // },
    keyEnter() {
      if (this.locationEntries.length == 0) {
        //se ha pulsado sin sugerencias
        this.geocodeAddress();
      } else {
        this.autocompleteLocationModel = this.locationEntries[0];
        this.geocodeAddress();
      }
    },
    // geocodeAddress: function(event) {

    // 	return new Promise((resolve, reject) => {

    // 			let _vue = this;
    // 			let address = "";

    // 			if (!this.buscando) {
    // 				this.buscando = true;
    // 				if (
    // 					_vue.locationFoundItems[0] == undefined &&
    // 					!this.autocompleteLocationModel
    // 				) {
    // 					_vue.$store.commit("snackbar/setMensajeDanger", {
    // 						msj: "No se localiza la dirección indicada"
    // 					});
    // 				} else {

    // 					if (event != undefined && event.value != undefined) {
    // 						address = event.value;
    // 						this.autocompleteLocationModel = event.value;
    // 					} else if (this.locationFoundItems[0]) {
    // 						address = this.locationFoundItems[0].value;
    // 						this.autocompleteLocationModel = this.locationFoundItems[0].value;
    // 					} else {
    // 						console.log("No se localiza");
    // 					}

    // 					let noselocaliza = this.locationEntries.includes(
    // 						"No se localiza. Escribir a mano."
    // 					);

    // 					if (noselocaliza && _vue.modo == "domicilio") {
    // 						//Sin modal para recoger
    // 						_vue.openDialogDireccion(true);
    // 						_vue.buscando = false;
    // 						resolve("ok")
    // 					} else {
    // 						if(address != ""){

    // 							this.$store
    // 								.dispatch("pedido/geocodeAddress", address)
    // 								.then(data => {
    // 									_vue.$store.commit("direcciones/setDireccionInput", address);
    // 									_vue.$store.commit("pedido/setAddressObjectSinFiltro", data);
    // 									_vue.$store.commit("direcciones/setDirPidiendo", data);

    // 									if (_vue.modo == "domicilio") {
    // 										//Sin modal para recoger
    // 										_vue.openDialogDireccion(true);
    // 									}
    // 									return this.loadAndOrderRestaurants();
    // 								})
    // 								.then(() => {
    // 									_vue.locationEntries = [];
    // 								})
    // 								.catch(err => {
    // 									console.log(err);
    // 								})
    // 								.finally(function() {
    // 									_vue.buscando = false;
    // 									resolve("ok")

    // 								});
    // 						}else{
    // 							resolve("La direccion está vacía")
    // 						}
    // 					}
    // 				}
    // 			}
    // 	});
    // },
    // getNavigatorLocation() {
    // 	return new Promise((resolve, reject) => {
    // 		let _vue = this;
    // 		this.$store.commit("direcciones/setLoadingDireccionNavegador", true);

    // 		_vue.$store
    // 			.dispatch("pedido/getNavigatorLocation")
    // 			.then(data => {
    // 				if (data == "error") {
    // 					_vue.$store.commit("snackbar/setMensajeDanger", {
    // 						msj: "Debe activar la geolocalización si desea usarla"
    // 					});
    // 				}

    // 				_vue.$store
    // 					.dispatch("pedido/geocodeCoordinatesToAddress", data)
    // 					.then(data => {
    // 						if (data.ok == "ok") {
    // 							_vue.$store.commit(
    // 								"direcciones/setDireccionNavegador",
    // 								data.direccion
    // 							);
    // 							_vue.$store.commit(
    // 								"pedido/setAddressObjectSinFiltro",
    // 								data.direccion
    // 							);
    // 							_vue.autocompleteLocationModel = data.direccion.formated;

    // 							if (_vue.modo == "domicilio") {
    // 								//Abre modal de confirmacion en domicilio
    // 								_vue.openDialogDireccion(true);
    // 							} else {
    // 								//Reordena los restaurantes en recoger
    // 								this.loadAndOrderRestaurants();
    // 							}
    // 						} else {
    // 							_vue.$store.commit("snackbar/setMensajeInfo", {
    // 								msj: "Debe activar la geolocalización si desea usarla"
    // 							});
    // 						}
    // 					});
    // 			})
    // 			.finally(function() {
    // 				_vue.$store.commit("direcciones/setLoadingDireccionNavegador", false);
    // 				resolve("ok")
    // 			});
    // 		})
    // },
    addressExists() {
      this.$emit("update", true);
    },
    // openDialogDireccion(boolean) {
    // 	let _vue = this;
    // 	this.dialogDireccion = boolean;
    // 	this.$store.commit(
    // 		"direcciones/setAddressOnOpenDialog",
    // 		_vue.addressObject
    // 	);
    // },
    cargarLogica() {
      let _vue = this;

      switch (this.modo) {
        case "recoger":
          _vue.cargarLogicaRecoger().then(function(e) {
            // if (_vue.dirInput) {
            // 	_vue.autocompleteLocationModel = _vue.dirInput;
            // 	_vue.geocodeAddress()
            // 	.then(function(){
            // 		_vue.loadAndOrderRestaurants();
            // 	})
            // } else if (_vue.dirPidiendo) {
            // 	_vue.autocompleteLocationModel = _vue.dirPidiendo.formated;
            // 	_vue.loadAndOrderRestaurants();
            // } else {
            // 	_vue.getNavigatorLocation()
            // 	.then(function(){
            // 		_vue.loadAndOrderRestaurants();
            // 	})
            // }
          });

          break;
        case "domicilio":
          _vue.cargarLogicaDomicilio().then(function(e) {});
          // this.$store.commit("direcciones/setDireccionCache");
          // this.$store.dispatch("direcciones/localizarDireccion").then(() => {
          // 	// _vue.autocompleteLocationModel = _vue.addressObject.formated;
          // });
          break;
        default:
          console.log("Caso no controlado");
          break;
      }
    },
    cargarDireccionesUsuario() {
      //Trata de cargar las direcciones del usuario, si hay problemas prueba los otro métodos
      let _vue = this;
      let coordenadas;

      this.direcciones.forEach(function(e) {
        if (e.predeterminada) {
          coordenadas = e.coordenadas.split(",");
        }
      });
      if (coordenadas) {
        _vue.$store.commit("pedido/setNavigatorLocation", coordenadas);
        this.loadAndOrderRestaurants();
      } else if (Object.entries(this.direccionCache).length > 0) {
        this.loadLocalAddress();
      } else {
        this.getNavigatorLocation();
      }
    },
    // loadAndOrderRestaurants() {
    // 	let _vue = this;
    // 	this.loadingRest = true;

    // 	var p1 = _vue.$store
    // 		.dispatch("restaurante/getListadoRestNegMix")
    // 		.then(data => {
    // 			_vue.$store
    // 				.dispatch("pedido/reorderRestaurants")
    // 				.then(data => {
    // 					if (this.$router.currentRoute.path == "/pedir/recoger") {
    // 						if (data.length > 0) {
    // 							_vue.$store.dispatch(
    // 								"restaurante/reordenarRestaurantes",
    // 								data
    // 							);
    // 						} else {
    // 							_vue.$store.commit("snackbar/setMensajeInfo", {
    // 								msj: "No hay restaurantes por la zona"
    // 							});
    // 						}
    // 					}
    // 				})
    // 				.finally(function() {
    // 					_vue.loadingRest = false;
    // 					_vue.$store.commit("direcciones/setLoadingDireccionNavegador", false);
    // 				});
    // 		});
    // },
    loadLocalAddress() {
      this.$store.commit(
        "pedido/setAddressObjectSinFiltro",
        this.direccionCache
      );

      this.autocompleteLocationModel = this.direccionCache.formated;
      this.loadAndOrderRestaurants();
    }
  }
};
</script>
<style scoped>
</style>